import * as React from 'react';
import { observer } from 'mobx-react';
// helpers
import { useSelectOverrides } from './overrides';
// components
import { AsyncSelect } from '@sprinklr/spaceweb/asyncSelect';
// types
import { StyledAsyncSelectProps } from './types';

// isLoading prop is a workaround to hide the selected value while loading is taking place
// This addresses some weirdness with how the PickerValues is being used with brand/competitors UI where we are relying on resolveSelectedOptions to filter the selected values.
// This is seems like an incorrect usage of the AsyncSelect props API but.. too difficult for me to try an untangle all the HACKTOWN's without dedicating a few dozen story points
// in the interim the isLoading prop hides the selected values until the mutation has occurred.
const StyledAsyncSelect: React.FC<StyledAsyncSelectProps> = ({ isLoading, ...props }) => {
    const selectOverrides = useSelectOverrides(isLoading);
    return <AsyncSelect overrides={selectOverrides} {...props} />;
};

export default observer(StyledAsyncSelect);
